





















































import LazyComponent from "v-lazy-component/vue2";
import {
  useRoute,
  defineComponent,
  onMounted,
  computed,
  watch,
  ref,
  onBeforeUnmount,
  onUnmounted,
} from "@nuxtjs/composition-api";
import { useUiState } from "~/composables";
import { useAddToCartModal } from "~/composables/useAddToCartModal";
import AppHeader from "~/components/AppHeaderNew.vue";
import LoadWhenVisible from "~/components/utils/LoadWhenVisible.vue";
import TopBar from "~/components/TopBar/TopBarNew.vue";
import { useConfigStore } from "~/stores/extensionApi";
import { usePageStore } from "~/stores/page";
import { useUser } from "~/modules/customer/composables/useUser";
import { useTraverseCategory } from "~/modules/catalog/category/helpers/useTraverseCategory";
import { decodeUid } from "~/helpers";
import HeaderNavigation from "~/components/Header/Navigation/HeaderNavigationNew.vue";
const SearchPopup = () =>
  import("~/components/Header/SearchBar/SearchPopup.vue");
import { useClientStore } from "~/stores/client";

export default defineComponent({
  name: "DefaultLayout",

  components: {
    LoadWhenVisible,
    LazyComponent,
    AppHeader,
    TopBar,
    HeaderNavigation,
    SearchPopup,
    PopupFixTop: () => import("~/components/popup/PopupFixTop.vue"),
    PopupModal: () => import("~/components/popup/PopupModal.vue"),
    AppFooter: () =>
      import(/* webpackPrefetch: true */ "~/components/AppFooter.vue"),
    CartSidebar: () =>
      import(
        /* webpackPrefetch: true */ "~/modules/checkout/components/CartSidebarNew.vue"
      ),
    LoginModal: () =>
      import(
        /* webpackPrefetch: true */ "~/modules/customer/components/LoginModal/LoginModal.vue"
      ),
    Notification: () =>
      import(/* webpackPrefetch: true */ "~/components/Notification.vue"),
    AddToCartModal: () =>
      import(
        /* webpackPrefetch: true */ "~/modules/catalog/category/components/views/addtocart/AddToCartModal.vue"
      ),
  },

  setup() {
    const route = useRoute();
    const { routeData } = usePageStore();
    const pageStore = usePageStore();
    const clientStore = useClientStore();
    const pageType = computed(() => pageStore.getPageType);
    const pageLevel = computed(() => pageStore.getPageLevel);
    const { activeCategoryById } = useTraverseCategory();

    const { isSearchPopupOpen, toggleSearchPopup } = useUiState();

    const activeCategoryByUid = computed(() => {
      return activeCategoryById(decodeUid(routeData?.uid));
    });

    const displayMode = computed(() => {
      return activeCategoryByUid.value?.display_mode || "";
    });
    const classPage = ref("");
    const typePage = ref("");

    const { user: userCurrent, load: loadUser } = useUser();

    const configStore = useConfigStore();

    const popupFixTop = computed(() => configStore.getDataPopUpFixTop || []);
    const dataPopup = computed(() => configStore.getDataPopUp || []);

    const { useClevertapStore } = require("~/stores/clevertap");
    const clevertapStore = useClevertapStore();

    // Track page view flag to prevent duplicate events
    const pageViewTracked = ref(false);

    // Function to detect device type
    const getDeviceType = () => {
      if (!process.client) return "desktop";

      const ua = navigator.userAgent;
      if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
        return "tablet";
      }
      if (
        /Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
          ua
        )
      ) {
        return "mobile";
      }
      return "desktop";
    };

    // Function to detect OS
    const getOperatingSystem = () => {
      if (!process.client) return "others";

      const userAgent = window.navigator.userAgent;
      const platform = window.navigator.platform;

      // iOS detection
      if (
        /iPad|iPhone|iPod/.test(userAgent) ||
        (platform === "MacIntel" && navigator.maxTouchPoints > 1)
      ) {
        return "iOS";
      }

      // Android detection
      if (/Android/.test(userAgent)) {
        return "Android";
      }

      // Windows detection
      if (/Win/.test(platform)) {
        return "Windows";
      }

      // macOS detection
      if (/Mac/.test(platform)) {
        return "macOS";
      }

      // Linux detection
      if (/Linux/.test(platform)) {
        return "Linux";
      }

      return "others";
    };

    // Function to track page view
    const trackPageView = () => {
      if (!process.client || pageViewTracked.value) return;

      try {
        const win = window as any;
        if (!win.clevertap) return;

        const trackingData = {
          Device: getDeviceType(),
          OS: getOperatingSystem(),
          URL: window.location.href,
        };

        // Send event to CleverTap
        clevertapStore.pageViewCleverTap({
          clevertap: win.clevertap,
          data: trackingData,
        });

        // Mark as tracked
        pageViewTracked.value = true;
      } catch (error) {
        console.error("Error tracking page view:", error);
      }
    };

    const {
      isCartSidebarOpen,
      isWishlistSidebarOpen,
      isLoginModalOpen,
      toggleLoginModal,
    } = useUiState();

    const displayLiveChat = () => {
      let livechatEl = document.getElementById("oc-widget");
      if (livechatEl) {
        livechatEl.style.display = "block";
      }
    };

    const toggleBodyOverflow = (value) => {
      document.body.classList.toggle("no-scroll", value);
    };
    watch(isCartSidebarOpen, (newVal) => {
      toggleBodyOverflow(newVal);
    });

    // Track UTM parameters with tracking prevention
    const utmTracked = ref(new Set()); // Store tracked UTM combinations

    const trackUTMParameters = () => {
      if (!process.client || !window.clevertap) return;

      const urlParams = new URLSearchParams(window.location.search);
      const utmSource = urlParams.get("utm_source");
      const utmMedium = urlParams.get("utm_medium");
      const utmCampaign = urlParams.get("utm_campaign");

      if (utmSource || utmMedium || utmCampaign) {
        // Create a unique key for this UTM combination
        const utmKey = `${utmSource || ""}_${utmMedium || ""}_${
          utmCampaign || ""
        }`;

        // Check if we've already tracked this exact UTM combination
        if (utmTracked.value.has(utmKey)) {
          return; // Skip if already tracked
        }

        const trackingData = {
          utm_source: utmSource || "",
          utm_medium: utmMedium || "",
          utm_campaign: utmCampaign || "",
        };

        clevertapStore.utmVisitedCleverTap({
          clevertap: window.clevertap,
          data: trackingData,
        });

        // Mark this UTM combination as tracked
        utmTracked.value.add(utmKey);
      }
    };

    // Reset UTM tracking when component is destroyed
    onBeforeUnmount(() => {
      utmTracked.value.clear(); // Clear the tracked UTMs
    });

    onMounted(async () => {
      if (!userCurrent?.value?.id) {
        await loadUser();
      }
      await clientStore.setClientIp();
      displayLiveChat();
      trackPageView();

      // Call the UTM tracking function on page load
      trackUTMParameters();
    });

    watch(
      () => route.value,
      () => {
        classPage.value =
          route.value.path == "/"
            ? "CMS_PAGE"
            : (pageType.value ?? "") + (pageLevel.value?.toString() ?? "");

        // Reset page view tracking flag when route changes
        pageViewTracked.value = false;

        // Track page view after a short delay to ensure everything is loaded
        setTimeout(() => {
          trackPageView();
        }, 300);

        // Call the UTM tracking function on route change but only once
        setTimeout(() => {
          trackUTMParameters();
        }, 300);
      },
      { immediate: true }
    );

    watch(
      () => route.value,
      () => {
        typePage.value =
          route.value.path == "/" ? "HOME" : pageType.value.toUpperCase();
        if (pageType.value.toUpperCase() == "CMS_PAGE") {
          typePage.value = "LANDING";
        }
        if (route.value.path == "/checkout") {
          typePage.value = "CHECKOUT";
        }
      },
      { immediate: true }
    );

    const {
      isOpenModal,
      modalProduct,
      modalSelectedOptions,
      closeAddToCartModal,
    } = useAddToCartModal();

    const goToTop = () => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    };

    return {
      isCartSidebarOpen,
      isWishlistSidebarOpen,
      isLoginModalOpen,
      toggleLoginModal,
      route,
      classPage,
      typePage,
      pageType,
      isOpenModal,
      modalProduct,
      modalSelectedOptions,
      closeAddToCartModal,
      popupFixTop,
      dataPopup,
      displayMode,
      goToTop,
      isSearchPopupOpen,
      toggleSearchPopup,
    };
  },

  head: {
    htmlAttrs: {
      lang: "vi",
    },
    link: [
      {
        rel: "preload",
        as: "font",
        href: "/Montserrat-SemiBold.woff",
        type: "font/woff",
        crossorigin: "anonymous",
      },
      {
        rel: "preload",
        as: "font",
        href: "/Montserrat-SemiBold.woff",
        type: "font/woff2",
        crossorigin: "anonymous",
      },
      {
        rel: "preload",
        as: "font",
        href: "/Montserrat-Regular.woff",
        type: "font/woff",
        crossorigin: "anonymous",
      },
      {
        rel: "preload",
        as: "font",
        href: "/Montserrat-Regular.woff",
        type: "font/woff2",
        crossorigin: "anonymous",
      },
      {
        rel: "preload",
        as: "font",
        href: "/Montserrat-Bold.woff",
        type: "font/woff",
        crossorigin: "anonymous",
      },
      {
        rel: "preload",
        as: "font",
        href: "/Montserrat-Bold.woff",
        type: "font/woff2",
        crossorigin: "anonymous",
      },
    ],
  },
});
